import { LookupItem } from "@amsanalytics/react-shared-library";

export const ApplicationStatuses = {
  approved: "7D2C21A5-FA9B-423B-BEFE-335067650996",
  archived: "1F9DF23A-BD88-4515-B421-5562DD15C758",
  additionalInformationRequired: "D48EB79A-8359-462E-BA04-CB7A5D894F92",
  closed: "84952ACE-EAA8-499F-9F32-829D1ABE4165", // Made for ACC because they have a "Closed" and a "Lost" status
  closedLost: "D47FE765-958B-4B23-9E3A-71A18AF84D9C",
  collection: "E1AB74BE-D2EE-4AA1-8091-79AE525B568C",
  conditionallyApproved: "598DF346-837F-4675-B8C6-C96D65CD93B7",
  conditionsTentativelySatisfied: "30792AF9-54E5-429B-AE1C-88B99A196FB6",
  denied: "D474A446-2298-42E0-BCB8-D59DE21206E5",
  desking: "4F0847BE-A121-4BE9-81B5-32EC1B9F3DA4",
  duplicate: "00EDC88B-656F-4888-B290-635711B6EF59",
  finalizedPosted: "2B9A397F-6BB3-44BF-8E0B-8A471BEC9438",
  funded: "13EA3E70-0908-4221-A58C-A03618FBC0F3",
  hidden: "BC32E898-20C5-41AE-A10D-B62CF94C14DA",
  hold: "A7901B15-B647-4ACC-BA86-FB99A2069803",
  investigation: "F0B577C8-7BA5-4524-85CF-38EF5B7DB7B0",
  new: "74C5F746-78C5-49AC-8C17-92A30D5BE807",
  rehash: "67DFFDD2-1AF7-483F-A586-E2697F8F19B0",
  removedApplicant: "67075A77-4C32-4E7E-9BC9-02E07672A260",
  sales: "23C7FBAD-2F8A-4948-B777-AEA0F7532236",
  underwriting: "16FF897F-5EFF-4919-A9E9-D2258E1759E5",
  unwound: "A1D02F47-AA65-49F9-B883-DC2307C9FA32",
};

export const CustomerRoles = {
  applicant: "cba13ec8-d9b6-4074-90c5-bdd7e2cc7a4f",
  coApplicant: "eef728e9-8bfa-49fa-8ac1-cc42573618ea",
  coApplicant2: "63925d33-f9bc-41c0-bd06-e013442faa70",
};
// List of relationship types for users to select from the dropdown menus when creating applications.
export const defaultRelationshipTypes: LookupItem[] = [
  {
    id: "0",
    name: "Applicant",
    sortOrder: 0,
    description: "Applicant",
  },
  {
    id: "1",
    name: "Spousal",
    sortOrder: 1,
    description: "Spousal",
  },
  {
    id: "2",
    name: "Parental",
    sortOrder: 2,
    description: "Parental",
  },
  {
    id: "3",
    name: "Other",
    sortOrder: 3,
    description: "Other",
  },
];

export const applicationSources = {
  poralLink: "Portal Link",
  websiteEmbed: "Website Embed",
};
